import React from 'react'
import { format } from 'date-fns'
import Page from '../../components/Page'

import { getAllStories, getStory } from '../../data/stories'
import { getAcfArticle } from '../../data/news'

export default function Home (props) {
  const article = props.page.fullArticle
  if (article.embedded) {
    var image = article._embedded['wp:featuredmedia'][0]
  } else {
    var image = '/public-next/images/quell-placeholder.png'
  }

  return (
    <div id='page' className='site'>
      <Page
        title={
          article.title.rendered.replace(
            /&#8217;/g,
            "'"
          ) /*removes wordpress html code for an apostrophe and replaces it with an actual one*/
        }
        body={article.excerpt.rendered}
        heroBody={props.page.acf.hero.body}
        hideDate={props.page.acf.hero.hideDate}
        bgImage={props.page.acf.hero.bgImage}
        bgId={image.id}
        alt={image.alt}
        height={image.height}
        width={image.width}
        slug={'/' + article.slug}
        bottomLeft
        disableArrow
      >
        <main id='content' className='single-story'>
          <div
            className='container'
            dangerouslySetInnerHTML={{
              __html: props.page.fullArticle.content.rendered
            }}
          />
        </main>
      </Page>
      <style jsx>{`
        @media (min-width: 960px) {
          .container {
            padding: 5rem 20rem;
          }
        }

        p,
        p *,
        ul *,
        li,
        li * {
          color: #3a434f;
          font-family: Europa, sans-serif;
        }
      `}</style>
    </div>
  )
}

///wp-json/wp/v2/posts?slug=post-slug

export async function getStaticProps ({ context, params }) {
  let fullArticle = await getStory(params.slug)
  let fullAcfStory = await getAcfArticle(params.id)

  const page = {
    acf: {
      hero: {
        title: fullArticle.title.rendered,
        body:
          '<p>' + format(new Date(fullArticle.date), 'MMMM dd, yyyy') + '</p>',
        bgImage: fullArticle._embedded['wp:featuredmedia']
          ? fullArticle._embedded['wp:featuredmedia'][0].source_url
          : '/public-next/images/quell-placeholder.png',
        hideDate:
          fullArticle.acf.hide_date === null
            ? null
            : fullArticle.acf.hide_date[0] || null
      }
    },
    fullArticle,
    fullAcfStory
  }

  return {
    props: {
      page
    }
  }
}

export async function getStaticPaths (context) {
  const stories = await getAllStories()
  const paths = stories.map(story => ({
    params: story
  }))

  return {
    paths,
    fallback: false
  }
}
